import { UrlSegment, UrlMatchResult } from '@angular/router';

export function regionMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  const validRegions = ['en-us', 'sv-se', 'no-no', 'fi-fi', 'da-dk', 'de-de'];
  if (segments.length && validRegions.includes(segments[0].path)) {
    return {
      consumed: [segments[0]],
      posParams: { region: segments[0] }
    };
  }
  return null;
}
